import { Badge } from "react-bootstrap";
import styled from "styled-components";
import LocalizedStrings from 'react-localization';

import { ClientLanguage, getClientLanguageAsString } from "../Api"

const Box = styled.div`
    margin-left: 6px;
    user-select: none;
`;

let locStrings = new LocalizedStrings({
    de:
    {
        bagdePreview:"Entwurf",
    },
    en: 
    {
        bagdePreview:"Preview",
    }
});

interface PreviewProps {
    clientLanguage?: ClientLanguage
}

export const Preview = (props: PreviewProps) => {

    setLanguage();

    function setLanguage(): void {
        switch(props.clientLanguage) { 
            case ClientLanguage.German: { 
               locStrings.setLanguage('de');
               break; 
            } 
            case ClientLanguage.English: { 
               locStrings.setLanguage('en'); 
               break; 
            } 
            // Otherwise "props.clientLanguage" is "ClientLanguage.BrowserSetting" and language used is browser setting dependent.
        } 
    }

    return (
        <Box>
            <Badge bg="secondary">{locStrings.bagdePreview}</Badge>
        </Box>
    );
}